import React from "react";
import { useEffect, useState } from "react";
import logo from "../images/logoOnly.png";
import logoIcon from "../images/logoOnly.png";

const ResponsiveHero = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  if (isMobile) {
    return (
      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 font-[Poppins]">
        <div className="mb-6">
          <img
            src={logo}
            alt="Logo Logistica Huemul"
            className="object-cover w-32 h-32"
          />
        </div>
        <div
          className="rounded-xl p-6 w-full"
          style={{
            backgroundColor: "hsla(220, 60%, 20%, 0.75)",
          }}
        >
          <h1 
            className="text-3xl font-logistica text-white text-center"
            style={{
              letterSpacing: '0.05em',
              lineHeight: '0.9',
              textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)',
              fontWeight: 'normal',
              fontStretch: 'expanded'
            }}
          >
            LOGÍSTICA HUEMUL
          </h1>
          <h2 
            className="text-xl font-medium text-white text-center mt-2 font-[Poppins]"
            style={{
              fontStyle: 'italic',
              letterSpacing: '0.02em',
            }}
          >
            Siempre cerca, aunque vayas lejos
          </h2>
          <p className="text-sm text-white text-center leading-relaxed mt-4 font-[Poppins]">
            Ofrecemos soluciones logísticas eficientes y confiables, conectando
            a nuestros clientes con sus destinos de manera segura y puntual. Día
            a día y desde hace 10 años, nos esforzamos por ser el socio
            logístico preferido en la industria, fruto de nuestro servicio
            personalizado, comprometido y de alta calidad.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="absolute inset-0 flex items-start pt-20 px-4 sm:px-6 lg:px-8 font-[Poppins]">
      <div className="max-w-[800px] text-white z-10">
        <div className="flex flex-col gap-8">
          <div>
            <div className="">
              <div className="w-[450px]" style={{ padding: "30px 20px 10px 20px" }}>
                <div className="flex items-end">
                  <img
                    src={logoIcon}
                    alt="Logo Huemul"
                    className="object-cover w-24 h-24 mr-4"
                  />
                  <h1 
                    className="text-7xl font-logistica leading-none pb-0"
                    style={{
                      letterSpacing: '0.05em',
                      lineHeight: '0.9',
                      textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)',
                      fontWeight: 'normal'
                    }}
                  >
                    LOGÍSTICA
                  </h1>
                </div>
              </div>

              <div className="w-[450px]" style={{ padding: "10px 20px 20px 20px" }}>
                <h1 
                  className="text-9xl font-logistica w-full ml-4"
                  style={{
                    letterSpacing: '0.05em',
                    lineHeight: '0.9',
                    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)',
                    fontWeight: 'normal',
                    fontStretch: 'expanded'
                  }}
                >
                  HUEMUL
                </h1>
              </div>
            </div>
            <div className="max-w-[450px] mt-8 px-5">
              <h2 
                className="text-3xl font-normal mb-4 font-[Poppins]"
                style={{
                  fontStyle: 'italic',
                  letterSpacing: '0.02em',
                }}
              >
                Siempre cerca,
                <br />
                aunque vayas lejos.
              </h2>
              <p className="text-sm leading-relaxed font-[Poppins]">
                Ofrecemos soluciones logísticas, eficientes y confiables. Desde
                hace 10 años nos esforzamos por estar en la vanguardia del
                servicio, innovando e incorporando soluciones para nuestros
                clientes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsiveHero;
